(function() {

	'use strict';

	/* jshint ignore:start */

	// Array.filter shim: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
	if ( !Array.prototype.filter ) {

		Array.prototype.filter = function( fun /*, thisArg*/ ) {
			'use strict';

			if ( this === void 0 || this === null ) {
				throw new TypeError();
			}

			var t = Object( this );
			var len = t.length >>> 0;
			if ( typeof fun !== 'function' ) {
				throw new TypeError();
			}

			var res = [];
			var thisArg = arguments.length >= 2 ? arguments[ 1 ] : void 0;
			for ( var i = 0; i < len; i++ ) {
				if ( i in t ) {
					var val = t[ i ];

					// NOTE: Technically this should Object.defineProperty at
					//       the next index, as push can be affected by
					//       properties on Object.prototype and Array.prototype.
					//       But that method's new, and collisions should be
					//       rare, so use the more-compatible alternative.
					if ( fun.call( thisArg, val, i, t ) ) {
						res.push( val );
					}
				}
			}

			return res;
		};
	}

	if ( typeof Object.create !== 'function' ) {

		Object.create = ( function() {

			var Object = function() {};

			return function ( prototype) {

				if ( arguments.length > 1 ) {

					throw Error( 'Second argument not supported' );
				}

				if ( typeof prototype !== 'object' ) {
					throw TypeError( 'Argument must be an object' );
				}

				Object.prototype = prototype;
				var result = new Object();
				Object.prototype = null;

				return result;
			};
		})();
	}

	if ( !Object.keys ) {

		Object.keys = (function() {

			var hasOwnProperty = Object.prototype.hasOwnProperty,
					hasDontEnumBug = !({ toString: null }).propertyIsEnumerable( 'toString' ),
					dontEnums = [
						'toString',
						'toLocaleString',
						'valueOf',
						'hasOwnProperty',
						'isPrototypeOf',
						'propertyIsEnumerable',
						'constructor'
					],
					dontEnumsLength = dontEnums.length;

			return function( obj ) {

				if ( typeof obj !== 'object' && ( typeof obj !== 'function' || obj === null ) ) {

					throw new TypeError( 'Object.keys called on non-object' );
				}

				var result = [], prop, i;

				for ( prop in obj ) {

					if ( hasOwnProperty.call( obj, prop ) ) {

						result.push(prop);
					}
				}

				if ( hasDontEnumBug ) {

					for ( i = 0; i < dontEnumsLength; i = i + 1 ) {

						if ( hasOwnProperty.call( obj, dontEnums[i] ) ) {

							result.push(dontEnums[i]);
						}
					}
				}
				return result;
			};
		}() );
	}
	/* jshint ignore:end */

} )();

define("lib/ieshims", function(){});

